/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { toast } from "react-hot-toast";
import Card from "../../../../../components/Cards/Card";
import { ManagerService } from "../../../../../utils/services/manager.service";

function AdditionalEmailgroups({ dictionary }) {
  const [open] = useState(false);
  const [loading, setLoading] = useState(false);
  const [color, setColor] = useState(false);
  const [submitTransaction, setSubmitTransaction] = useState({
    emails: "",
    emailMessageId: "TRANSACTION_CREATED_MESSAGES",
  });
  const [payForTransaction, setPayForTransaction] = useState({
    emails: "",
    emailMessageId: "AWAITING_PAYMENT_MESSAGES",
  });
  const [approveTransaction, setApproveTransaction] = useState({
    emails: "",
    emailMessageId: "CONFIRM_TRANSACTION_MESSAGE",
  });
  const [payOut, setPayout] = useState({
    emails: "",
    emailMessageId: "TRANSACTION_PAID_OUT_MESSAGE",
  });
  const [globalExchange, setGlobalExchange] = useState({
    emails: "",
    emailMessageId: "EXCHANGE_SELLING_RATE_MESSAGES",
  });
  const [transaction, setTransaction] = useState({
    emails: "",
    emailMessageId: "TRANSACTION_CANCELLED_OR_REFUNDED_MESSAGES",
  });

  const setUpAdditionalEmailGroup = async (payload) => {
    setLoading(true);
    try {
      const response = await ManagerService.setUpAdditionalEmailGroup(payload);
      console.log(response, "lo");
      if (response.data.status === "SUCCESS") {
        toast.success(response?.data?.data);
        setSubmitTransaction({});
        setApproveTransaction({});
        setGlobalExchange({});
        setPayForTransaction({});
        setPayout({});
        setTransaction({});
      }
    } catch (error) {
      return error;
    }
    setLoading(false);
  };

  const payload = [
    { ...submitTransaction },
    { ...payForTransaction },
    { ...approveTransaction },
    { ...payOut },
    { ...globalExchange },
    { ...transaction },
  ];

  return (
    <>
      <Card>
        <ul className="list-group">
          <li
            className="list-group-item collapse-text text-uppercase fw-bold"
            onClick={() => setColor(!color)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
            style={{ cursor: "pointer", borderBottom: "0px solid" }}
          >
            {color ? (
              <i className="fa fa-minus" aria-hidden="true" />
            ) : (
              <i className="fa fa-plus" aria-hidden="true" />
            )}{" "}
            &nbsp;
            {dictionary
              ? dictionary["WO_ADDITIONAL_EMAIL_GRO_1203361002"]
              : "Additional email groups"}
          </li>

          <Collapse in={color}>
            <div id="example-collapse-text" className="px-3">
              <div className="form form-row pt-4 mt-4">
                <div className="col-lg-12 col-md-12 mb-3">
                  <label>
                    {dictionary
                      ? dictionary["button_submit_transaction"]
                      : "Submit Transaction"}
                  </label>
                  <textarea
                    value={submitTransaction.emails}
                    onChange={(e) => {
                      setSubmitTransaction({
                        emails: e.target.value,
                        emailMessageId: e.target.name,
                      });
                    }}
                    className="form-control px-3 py-5"
                    placeholder={`${
                      dictionary
                        ? dictionary["WO_USE_COMMA_SEPARATED_-1360503130"]
                        : "Use comma separated text. e.g. support@moneytransferapplication.co.uk, info@moneytransferapplication.co.uk"
                    }`}
                    name="TRANSACTION_CREATED_MESSAGES"
                  />
                </div>

                <div className="col-lg-12 col-md-12 mb-3 mt-2">
                  <label>
                    {dictionary
                      ? dictionary["WO_PAYMENT_FOR_THE_TRAN_-987212878"]
                      : "Payment for the Transaction"}
                  </label>
                  <textarea
                    value={payForTransaction.emails}
                    onChange={(e) => {
                      setPayForTransaction({
                        emails: e.target.value,
                        emailMessageId: e.target.name,
                      });
                    }}
                    className="form-control px-3 py-5"
                    placeholder={`${
                      dictionary
                        ? dictionary["WO_USE_COMMA_SEPARATED_-1360503130"]
                        : "Use comma separated text. e.g. support@moneytransferapplication.co.uk, info@moneytransferapplication.co.uk"
                    }`}
                    name="AWAITING_PAYMENT_MESSAGES"
                  />
                </div>

                <div className="col-lg-12 col-md-12 mb-3 mt-2">
                  <label>
                    {dictionary
                      ? dictionary["WO_TRANSACTION_APPROVA_713395408"]
                      : "Transaction Approval"}
                  </label>
                  <textarea
                    value={approveTransaction.emails}
                    onChange={(e) => {
                      setApproveTransaction({
                        emails: e.target.value,
                        emailMessageId: e.target.name,
                      });
                    }}
                    className="form-control px-3 py-5"
                    placeholder={`${
                      dictionary
                        ? dictionary["WO_USE_COMMA_SEPARATED_-1360503130"]
                        : "Use comma separated text. e.g. support@moneytransferapplication.co.uk, info@moneytransferapplication.co.uk"
                    }`}
                    name="CONFIRM_TRANSACTION_MESSAGE"
                  />
                </div>

                <div className="col-lg-12 col-md-12 mb-3 mt-2">
                  <label>
                    {dictionary ? dictionary["para_pay_out"] : "Pay Out"}
                  </label>
                  <textarea
                    value={payOut.emails}
                    onChange={(e) => {
                      setPayout({
                        emails: e.target.value,
                        emailMessageId: e.target.name,
                      });
                    }}
                    className="form-control px-3 py-5"
                    placeholder={`${
                      dictionary
                        ? dictionary["WO_USE_COMMA_SEPARATED_-1360503130"]
                        : "Use comma separated text. e.g. support@moneytransferapplication.co.uk, info@moneytransferapplication.co.uk"
                    }`}
                    name="TRANSACTION_PAID_OUT_MESSAGE"
                  />
                </div>

                <div className="col-lg-12 col-md-12 mb-3 mt-2">
                  <label>
                    {dictionary
                      ? dictionary["WO_GLOBAL_EXCHANGE_RAT_-1057628196"]
                      : "Global Exchange Rate"}
                  </label>
                  <textarea
                    value={globalExchange.emails}
                    onChange={(e) => {
                      setGlobalExchange({
                        emails: e.target.value,
                        emailMessageId: e.target.name,
                      });
                    }}
                    className="form-control px-3 py-5"
                    placeholder={`${
                      dictionary
                        ? dictionary["WO_USE_COMMA_SEPARATED_-1360503130"]
                        : "Use comma separated text. e.g. support@moneytransferapplication.co.uk, info@moneytransferapplication.co.uk"
                    }`}
                    name="EXCHANGE_SELLING_RATE_MESSAGES"
                  />
                </div>

                <div className="col-lg-12 col-md-12 mb-3 mt-2">
                  <label>
                    {dictionary
                      ? dictionary["WO_TRANSACTION_CANCELLA_-596868027"]
                      : "Transaction Cancellation"}
                  </label>
                  <textarea
                    value={transaction.emails}
                    onChange={(e) => {
                      setTransaction({
                        emails: e.target.value,
                        emailMessageId: e.target.name,
                      });
                    }}
                    className="form-control px-3 py-5"
                    placeholder={`${
                      dictionary
                        ? dictionary["WO_USE_COMMA_SEPARATED_-1360503130"]
                        : "Use comma separated text. e.g. support@moneytransferapplication.co.uk, info@moneytransferapplication.co.uk"
                    }`}
                    name="TRANSACTION_CANCELLED_OR_REFUNDED_MESSAGES"
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-3" />
                <div className="col-lg-6 col-md-6 mb-3 mt-4">
                  <button
                    onClick={() => setUpAdditionalEmailGroup(payload)}
                    className="login100-form-btn btn-primary fw-bold text-uppercase"
                    type={"button"}
                  >
                    {loading ? (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    ) : (
                      `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </ul>
      </Card>
    </>
  );
}

export default AdditionalEmailgroups;
